import { z } from 'zod';

export const documentSubmitSummaryDtoSchema = z.object({
  id: z.string().uuid(),
  documentId: z.string().uuid(),
  submittedByUserId: z.string().uuid(),
  submittedByAlias: z.string(),
  strictValidation: z.boolean(),
  createdAt: z.string().datetime(),
});

export type DocumentSubmitSummaryDto = z.infer<typeof documentSubmitSummaryDtoSchema>;
